import React, { useContext, useEffect, useState } from "react";
import { Drawer, Select, DatePicker, Space } from "antd";
import { FileProps } from "../../../interfaces/interfaces";
import dayjs from "dayjs";
import DataContext from "../../../context/DataContext";
import { FilesTable } from "./FilesTable";
import { filterOption } from "../../../utils/func/utils";
const { RangePicker } = DatePicker;

interface Props {
  idClient: string;
  idCustomer: string;
  open: boolean;
  onClose: () => void;
}

export const CustomerFilesDrawer: React.FC<Props> = ({
  open,
  idClient,
  idCustomer,
  onClose,
}) => {
  const [filterProject, setFilterProject] = useState<string | undefined>();
  const [filterUser, setFilterUser] = useState<string | undefined>();
  const [filterDateRange, setFilterDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | null
  >(null);
  const { customerFiles, usersList, projectList, getDataById } =
    useContext(DataContext);
  const [filesFilter, setFilesFilter] = useState<any>({
    active: true,
    search: undefined,
  });

  useEffect(() => {
    if (open) fetchFiles();
  }, [open, idClient, idCustomer, filesFilter]);

  const fetchFiles = async () => {
    let { search, ...filters } = filesFilter;
    console.log(filters);
    try {
      getDataById({
        type: "customer-files",
        endpoint: `files/${idClient}`,
        filters: {
          customer: idCustomer,
          ...filters,
        },
        search: search,
      });
    } catch (err) {
      console.error("Failed to fetch files", err);
    }
  };

  useEffect(() => {
    if (filterUser) {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadedBy: filterUser,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadedBy: undefined,
      }));
    }
    if (filterProject) {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: filterProject,
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        project: undefined,
      }));
    }
    if (filterDateRange) {
      const [start, end] = filterDateRange;
      const startOfDay = start.startOf("day");
      const endOfDay = end.endOf("day");
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: {
          $gte: startOfDay.toISOString(),
          $lte: endOfDay.toISOString(),
        },
      }));
    } else {
      setFilesFilter((prev: any) => ({
        ...prev,
        uploadDate: undefined,
      }));
    }
  }, [filterUser, filterProject, filterDateRange]);

  return (
    <Drawer
      title="Customer Files"
      placement="right"
      onClose={onClose}
      open={open}
      width={900}
    >
      <Space
        direction="vertical"
        size="middle"
        style={{
          marginBottom: 16,
          width: "100%",
        }}
        className="customer-files-filters"
      >
        <Space
          wrap
          style={{
            width: "100%",
            justifyContent: "center",
            gap: 16,
          }}
        >
          <Select
            allowClear
            filterOption={filterOption}
            showSearch
            placeholder="Filter by User"
            style={{ minWidth: 200, flex: 1 }}
            onChange={(value) => setFilterUser(value)}
            value={filterUser}
            options={usersList.map((user) => ({
              label: user.name,
              value: user._id,
            }))}
          />
          <Select
            allowClear
            filterOption={filterOption}
            showSearch
            placeholder="Filter by Project"
            style={{ minWidth: 200, flex: 1 }}
            onChange={(value) => setFilterProject(value)}
            value={filterProject}
            options={(projectList ?? [])
              .filter((project) =>
                project.customers
                  .map((customer) => customer?._id)
                  .includes(idCustomer),
              )
              .map((project) => ({
                label: project.name,
                value: project._id,
              }))}
          />
          <RangePicker
            onChange={(dates) =>
              setFilterDateRange(dates as [dayjs.Dayjs, dayjs.Dayjs])
            }
            value={filterDateRange}
            style={{ minWidth: 220, flex: 1 }}
          />
        </Space>
      </Space>
      <FilesTable
        idClient={idClient || ""}
        files={customerFiles}
        onChangePage={(current, pageSize) => {
          setFilesFilter((prev: any) => ({
            ...prev,
            page: current,
            perPage: pageSize,
          }));
        }}
      />
    </Drawer>
  );
};
